import { lazy } from "react";

export const Playground = lazy(() => import("./Playground_"));
